export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}

	const { order, injured, setting } = this
	let operationInfo = (injured && injured.operationInfo) || {}
	let arr = []

	function getPhoneLabelArr(label, phoneStr, extraOpts = {}) {
		let res = []
		let phoneArr = (phoneStr || '').split(',')
		phoneArr.forEach((item, index) => {
			res.push({
				label: `${label}${phoneArr.length > 1 ? index + 1 : ''}`,
				value: item,
				...extraOpts,
			})
		})
		return res
	}

	arr.push(
		{
			label: '法庭名称',
			value: operationInfo.courtName,
		},
		...getPhoneLabelArr('联系方式', operationInfo.courtPhone),
		{
			label: '法官姓名',
			value: operationInfo.judge,
		},
		...getPhoneLabelArr('法官联系方式', operationInfo.judgePhone),
		{
			label: '本方代理人',
			value: operationInfo.ownAgentName,
		},
		...getPhoneLabelArr('联系方式', operationInfo.ownAgentPhone),
		{
			label: '对方代理人',
			value: operationInfo.opposeAgentName,
		},
		...getPhoneLabelArr('联系方式', operationInfo.opposeAgentPhone)
	)
	return {
		title: '信息',
		children: arr,
	}
}
